module.exports = __webpack_public_path__ + "static/img/gradeHa.077c104.png";